"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_redux_1 = require("react-redux");
var ModalAlert_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalAlert"));
var ordered_1 = require("utils/selectors/ordered");
var SuccessModal = function (_a) {
    var onClose = _a.onClose, rechCustomer = _a.rechCustomer, sendAgreementDate = _a.sendAgreementDate;
    var allRechargeInvoices = (0, react_redux_1.useSelector)(ordered_1.selectRechargedInvoices);
    var todayISODate = (0, end2end_1.getISODate)(new Date());
    var isInvoiceSent = allRechargeInvoices === null || allRechargeInvoices === void 0 ? void 0 : allRechargeInvoices.some(function (rI) {
        var _a;
        return !['draft', 'scheduledForSending'].includes(rI.status)
            && rI.rechargedCustomerId === rechCustomer.id
            && (!((_a = rechCustomer.agreementInfo) === null || _a === void 0 ? void 0 : _a.cancelledAt) || rechCustomer.agreementInfo.cancelledAt < rI.date);
    });
    var isSentToday = sendAgreementDate === todayISODate;
    return ((0, jsx_runtime_1.jsx)(ModalAlert_1.default, { open: true, status: "success", title: "Customer Enabled", buttonText: "Excellent", onClose: onClose, description: ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ textAlign: "left", color: "riverstone" }, { children: ["The customer ", (0, jsx_runtime_1.jsx)("strong", { children: rechCustomer.name }), " is enabled and the agreement", ' ', (isInvoiceSent || !isSentToday) && 'and invoice ', isSentToday ? 'is sent to them' : "will be sent to them on ".concat(new Date(sendAgreementDate)), "."] }))) }));
};
exports.default = SuccessModal;
